import { render, staticRenderFns } from "./supplierTypeDialog.vue?vue&type=template&id=5c9d97b6&scoped=true&"
import script from "./supplierTypeDialog.vue?vue&type=script&lang=js&"
export * from "./supplierTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./supplierTypeDialog.vue?vue&type=style&index=0&id=5c9d97b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9d97b6",
  null
  
)

export default component.exports